import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { SORTING_CONTEXT_INITIAL_STATE } from '../constants';
import { SearchParamsContextState } from '../types';

export const initialSearchParamsState: SearchParamsContextState = {
  debouncedSearch: '',
  handleSort: noop,
  search: '',
  setSearch: noop,
  sortBy: SORTING_CONTEXT_INITIAL_STATE.sortBy,
  sortDirection: SORTING_CONTEXT_INITIAL_STATE.sortDirection,
};

export const SearchParamsContext = createContext(initialSearchParamsState);

export const useSearchParamsContext = () => useContext(SearchParamsContext);
